export type HSLColor = {
  h: number;
  s: number;
  l: number;
};

export const DULL_BLUE = { h: 215, s: 15, l: 56 };
export const SATURATED_BLUE = { h: 216, s: 92, l: 53 };

export function interpolateHSLColor(start: HSLColor, end: HSLColor, ratio: number): HSLColor {
  return {
    h: start.h + (end.h - start.h) * ratio,
    s: start.s + (end.s - start.s) * ratio,
    l: start.l + (end.l - start.l) * ratio,
  };
}

export function hslToString(hsl: HSLColor): string {
  return `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 1)`;
}
